import { API_BASE_URL } from './config';
// 간단한 공구 플로우 API 연동 예시 (fetch 기반)


// 1. 포스트 생성
export async function createPost(postData) {
  const res = await fetch(`${API_BASE_URL}/api/posts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(postData)
  });
  return await res.json();
}

// 2. 공구 참여
export async function participate(groupId, username) {
  // use group's join endpoint: POST /api/groups/{groupId}/join?username=...
  const res = await fetch(`${API_BASE_URL}/api/groups/${groupId}/join?username=${encodeURIComponent(username)}`, {
    method: 'POST'
  });
  const data = await res.json();
  if (!res.ok && data.error) {
    throw new Error(data.error);
  }
  return data;
}

// 3. 채팅방 이동
export async function getChatRoom(participationId) {
  // Chat room is returned by the join endpoint; keep endpoint if needed in future
  const res = await fetch(`${API_BASE_URL}/api/chatrooms?participationId=${participationId}`);
  return await res.json();
}

// 사용 예시 (React 컴포넌트 등에서)
// import { createPost, participate, getChatRoom } from '../api/groupFlow';
// const post = await createPost({ title: '테스트', groupId: 1 });
// const part = await participate(post.id, 'user1');
// const chatRoom = await getChatRoom(part.id);
// window.location.href = `/chat/${chatRoom.id}`;
